"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "54", height: "44", viewBox: "0 0 54 44", className: "Icon image-form-upload", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M36 40.966h7.326C49.22 40.966 54 35.936 54 29.733c0-5.776-4.142-10.533-9.471-11.162.035-.46.052-.923.052-1.392C44.581 7.691 37.272 0 28.256 0 20.09 0 13.326 6.307 12.12 14.544 5.388 14.786 0 20.606 0 27.751c0 7.298 5.622 13.215 12.558 13.215h7.692v-1h-7.692C6.186 39.966 1 34.508 1 27.75c0-6.599 4.956-11.984 11.157-12.208l.833-.03.12-.824C14.259 6.848 20.68 1 28.257 1 36.708 1 43.58 8.233 43.58 17.18c0 .44-.016.88-.05 1.315l-.072.957.952.112C49.27 20.138 53 24.5 53 29.733c0 5.662-4.343 10.233-9.674 10.233H36v1zm-7-18.027V43.25h-1V22.939l-5.941 5.874-.356.351-.703-.71.356-.352 7.144-7.1 7.155 7.1.345.351-.682.711-.346-.351L29 22.939z", fill: "#D7D7D7", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/image-form-upload.js
// module id = 1807
// module chunks = 0